import React, { useState, useEffect } from 'react';
import { API_URL } from '../constants';

export function VistaAccesosExternos() {
  const [accesos, setAccesos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [nuevoEmail, setNuevoEmail] = useState('');
  const [nuevoNombre, setNuevoNombre] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [msg, setMsg] = useState(null);

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_URL + '?path=api/accesos/listar');
      const data = await res.json();
      if (data.success) setAccesos(data.accesos || []);
    } catch {}
    finally { setLoading(false); }
  };

  useEffect(() => { cargar(); }, []);

  const mostrarMsg = (texto, tipo = 'ok') => {
    setMsg({ texto, tipo });
    setTimeout(() => setMsg(null), 3500);
  };

  const handleAgregar = async () => {
    if (!nuevoEmail || !nuevoEmail.includes('@')) { mostrarMsg('Ingresa un correo válido.', 'err'); return; }
    setGuardando(true);
    try {
      const url = API_URL + `?path=api/accesos/guardar&payload=${encodeURIComponent(JSON.stringify({ email: nuevoEmail.trim().toLowerCase(), nombre: nuevoNombre.trim() }))}`;
      const res = await fetch(url);
      const data = await res.json();
      if (data.success) {
        setNuevoEmail(''); setNuevoNombre('');
        mostrarMsg('Acceso guardado correctamente.');
        await cargar();
      } else {
        mostrarMsg(data.error || 'Error al guardar.', 'err');
      }
    } catch { mostrarMsg('Error de conexión.', 'err'); }
    finally { setGuardando(false); }
  };

  const handleRevocar = async (email) => {
    if (!window.confirm(`¿Revocar acceso de ${email}?`)) return;
    try {
      const url = API_URL + `?path=api/accesos/eliminar&payload=${encodeURIComponent(JSON.stringify({ email }))}`;
      const res = await fetch(url);
      const data = await res.json();
      if (data.success) { mostrarMsg('Acceso revocado.'); await cargar(); }
      else mostrarMsg(data.error || 'Error.', 'err');
    } catch { mostrarMsg('Error de conexión.', 'err'); }
  };

  const thS = { padding: '10px 14px', textAlign: 'left', fontWeight: 600, fontSize: '12px', color: '#4b5563', borderBottom: '2px solid #e5e7eb' };
  const tdS = { padding: '10px 14px', fontSize: '13px', color: '#1f2937', borderBottom: '1px solid #f3f4f6' };

  return (
    <div style={{ padding: '24px', maxWidth: '720px' }}>
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ fontSize: '22px', fontWeight: 700, color: '#1d3d6b' }}>Accesos Externos</h1>
        <p style={{ color: '#6b7280', fontSize: '13px', marginTop: '2px' }}>
          Correos fuera de @acerosleal.com que pueden entrar al portal (practicantes, etc.)
        </p>
      </div>

      {/* Formulario agregar */}
      <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: '20px' }}>
        <p style={{ fontWeight: 600, fontSize: '14px', color: '#1d3d6b', marginBottom: '14px' }}>Agregar correo autorizado</p>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
          <div style={{ flex: '2', minWidth: '200px' }}>
            <label style={{ fontSize: '12px', color: '#6b7280', display: 'block', marginBottom: '4px' }}>Correo electrónico *</label>
            <input type="email" value={nuevoEmail} onChange={e => setNuevoEmail(e.target.value)}
              placeholder="practicante@gmail.com"
              style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '13px' }} />
          </div>
          <div style={{ flex: '1.5', minWidth: '160px' }}>
            <label style={{ fontSize: '12px', color: '#6b7280', display: 'block', marginBottom: '4px' }}>Nombre (opcional)</label>
            <input type="text" value={nuevoNombre} onChange={e => setNuevoNombre(e.target.value)}
              placeholder="Nombre del practicante"
              style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '13px' }} />
          </div>
          <button className="btn-primary" onClick={handleAgregar} disabled={guardando}
            style={{ whiteSpace: 'nowrap', height: '38px' }}>
            {guardando ? 'Guardando...' : '+ Agregar'}
          </button>
        </div>
        {msg && (
          <div style={{ marginTop: '10px', padding: '8px 12px', borderRadius: '6px', fontSize: '13px',
            background: msg.tipo === 'err' ? '#fef2f2' : '#f0fdf4',
            color: msg.tipo === 'err' ? '#dc2626' : '#166534',
            border: `1px solid ${msg.tipo === 'err' ? '#fecaca' : '#bbf7d0'}` }}>
            {msg.tipo === 'err' ? '⚠️' : '✅'} {msg.texto}
          </div>
        )}
      </div>

      {/* Lista de accesos */}
      <div style={{ background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 600, fontSize: '14px', color: '#1f2937' }}>
            Correos autorizados ({accesos.filter(a => a.activo).length} activos)
          </span>
          <button className="btn-secondary" onClick={cargar} disabled={loading} style={{ fontSize: '12px', padding: '4px 10px' }}>
            <i className="ti ti-refresh"></i>
          </button>
        </div>
        {loading ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#9ca3af' }}>Cargando...</div>
        ) : accesos.length === 0 ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#9ca3af', fontSize: '13px' }}>
            <i className="ti ti-shield-off" style={{ fontSize: '32px', display: 'block', marginBottom: '8px' }}></i>
            No hay correos externos autorizados aún
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ background: '#f9fafb' }}>
              <tr>
                <th style={thS}>Correo</th>
                <th style={thS}>Nombre</th>
                <th style={thS}>Estado</th>
                <th style={thS}>Acción</th>
              </tr>
            </thead>
            <tbody>
              {accesos.map(a => (
                <tr key={a.email}>
                  <td style={tdS}>{a.email}</td>
                  <td style={{ ...tdS, color: '#6b7280' }}>{a.nombre || '—'}</td>
                  <td style={tdS}>
                    <span style={{ padding: '2px 10px', borderRadius: '10px', fontSize: '11px', fontWeight: 700,
                      background: a.activo ? '#d1fae5' : '#fee2e2',
                      color: a.activo ? '#065f46' : '#991b1b' }}>
                      {a.activo ? 'Activo' : 'Revocado'}
                    </span>
                  </td>
                  <td style={tdS}>
                    {a.activo && (
                      <button onClick={() => handleRevocar(a.email)}
                        style={{ padding: '3px 10px', border: '1px solid #fca5a5', borderRadius: '6px', background: '#fef2f2', color: '#dc2626', cursor: 'pointer', fontSize: '12px' }}>
                        Revocar
                      </button>
                    )}
                    {!a.activo && (
                      <button onClick={async () => {
                        const url = API_URL + `?path=api/accesos/guardar&payload=${encodeURIComponent(JSON.stringify({ email: a.email, nombre: a.nombre }))}`;
                        const res = await fetch(url); const data = await res.json();
                        if (data.success) { mostrarMsg('Acceso reactivado.'); cargar(); }
                      }}
                        style={{ padding: '3px 10px', border: '1px solid #6ee7b7', borderRadius: '6px', background: '#f0fdf4', color: '#065f46', cursor: 'pointer', fontSize: '12px' }}>
                        Reactivar
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
